import { render } from "./icon-full-screen.svg?vue&type=template&id=4ef93351"
const script = {}
script.render = render

export default script